// Mixin ułatwiający wyświetlanie modali
export const displayModalMixin = {
  data() {
    return { modals: {} };
  },
  methods: {
    // @vuese
    // Pokazuje modal o danej nazwie
    openModal(name) {
      this.$set(this.modals, name, true);
    },

    // @vuese
    // Ukrywa modal o danej nazwie
    closeModal(name) {
      this.$set(this.modals, name, false);
    }
  }
};
